import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Typography from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Typography';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import ErrorIcon from '@material-ui/icons/Error';
import classnames from 'classnames';
import Text from 'Components/ComponentLibrary/Atoms/Text';


const styles = (theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
  name: {
    fontSize: theme.typography.h6.fontSize,
    textTransform: 'uppercase',
  },
  value: {
    fontSize: theme.typography.h1.fontSize,
    color: theme.palette.facet.accentBlue19,
    marginBottom: theme.spacing(2),
  },
  warningContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: -theme.spacing(2),
  },
  warningIconContainer: {
    display: 'flex',
    marginRight: theme.spacing(2),
    color: theme.palette.warning.main,
    padding: theme.spacing(0.75),
    borderRadius: '50%',
    backgroundColor: theme.palette.facet.accentYellow1,
  },
  warningIcon: {
    fontSize: theme.typography.h5.fontSize,
  },
  warningMessage: {
    color: theme.palette.facet.primaryGray,
  },
  question: {
    marginBottom: theme.spacing(2),
  },
});

function RiskToleranceAnswers({
  name,
  value,
  warning,
  metaOptions,
  className,
  classes,
  questions,
}) {
  const [displayValue, setDisplayValue] = useState('');
  useEffect(() => {
    const optionFound = metaOptions.options.find(option => option.id === value);
    if (optionFound) {
      setDisplayValue(optionFound.prompt);
    }
  }, [value]);

  return (
    <div className={classnames(classes.root, className)}>
      <Typography className={classes.name}>{name}&apos;s Risk Tolerance</Typography>
      <Typography
        className={classes.value}
      >
        {displayValue}
      </Typography>
      {questions
        ? questions.map(question => {
          if (question.attributes.answer) {
            return (
              <div className={classes.question}>
                <Text variant="h6" color="primaryGray" weight="book" align="left">
                  {question.attributes.question}
                </Text>
                <Text variant="h6" color="darkGray" align="left">
                  {question.attributes.answer}
                </Text>
              </div>
            );
          }
          return undefined;
        })
        : null}
      {warning ? (
        <div className={classnames(classes.warningContainer)}>
          <div className={classnames(classes.warningIconContainer)}><ErrorIcon className={classnames(classes.warningIcon)} /></div>
          <Typography className={classnames(classes.warningMessage)}>{warning}</Typography>
        </div>
      ) : null}
    </div>
  );
}

RiskToleranceAnswers.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  warning: PropTypes.string,
  metaOptions: PropTypes.object.isRequired,
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  questions: PropTypes.arrayOf(PropTypes.object),
};

RiskToleranceAnswers.defaultProps = {
  className: undefined,
  warning: undefined,
  questions: undefined,
};

export default withStyles(styles)(RiskToleranceAnswers);
